import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "16_confirm.svg",
  "use": "16_confirm.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"16_confirm.svg\"><path fill=\"none\" d=\"M0 0h16v16H0z\" /><circle cx=\"7.5\" cy=\"7.5\" r=\"7\" fill=\"#fff\" stroke=\"#228bcb\" stroke-miterlimit=\"5\" /><path d=\"M5 4.91A2.52 2.52 0 017.4 3.5a2.43 2.43 0 012.7 2.38 2.2 2.2 0 01-1.49 2c-.61.34-1.12.59-1.11 1.3V10\" fill=\"#fff\" stroke=\"#228bcb\" stroke-miterlimit=\"5\" /><path fill=\"#238bcb\" d=\"M6.7 11h1.6v1.3H6.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol